// avcraft-shaped mock for the Tickets tab (Phase 3.1, mock-first). Content mirrors
// the design reference's mock data. Real data comes from GET /tickets/analysis
// (nightly job) + GET /tickets once the backend is deployed (Phase 3.2/3.3).
import type { TicketAnalysis, Ticket } from "../../../lib/brain-api";

const JIRA = "https://aeronetnz.atlassian.net/browse";

export const mockTicketAnalysis: TicketAnalysis = {
  customerId: "avcraft",
  generatedAt: "2026-07-17T02:14:00Z",
  summary: {
    text: "Quiet fortnight — 2 new tickets, both Garmin-related; PO-unlinking [ref:ticket:TICKET-22903] bounced back from the client; nothing aging badly.",
    refs: ["ticket:TICKET-22903"],
  },
  volume: {
    months: [
      { month: "2025-08", count: 4 },
      { month: "2025-09", count: 3 },
      { month: "2025-10", count: 5 },
      { month: "2025-11", count: 4 },
      { month: "2025-12", count: 2 },
      { month: "2026-01", count: 5 },
      { month: "2026-02", count: 3 },
      { month: "2026-03", count: 4 },
      { month: "2026-04", count: 3 },
      { month: "2026-05", count: 4 },
      { month: "2026-06", count: 3 },
      { month: "2026-07", count: 2 },
    ],
    baseline: 3.4,
  },
  responsiveness: {
    firstResponseHours: 4,
    firstResponseTrendPct: -12,
    resolutionDays: 6.2,
    resolutionTrendPct: 5,
  },
  waitingOn: { ourCourt: 3, withClient: 4, staleBothSides: 1, withClientOver21d: 1 },
  friction: {
    level: "elevated",
    reasons: [
      {
        text: "3 reopens on the same report issue [ref:ticket:TICKET-22881] — the client re-tested and found the export missing PO line-item costs each time.",
        refs: ["ticket:TICKET-22881", "visit:avcraft/2026-07-02"],
      },
    ],
  },
  themes: [
    {
      id: "pdf",
      name: "PDF / XLS report generation",
      openCount: 12,
      totalCount: 34,
      trend: "up",
      since: "recurring since 2024",
      synopsis: "PO & TD exports — the biggest recurring ask.",
      ticketKeys: ["TICKET-22902", "TICKET-22881"],
    },
    {
      id: "garmin",
      name: "Garmin inspections & limitations",
      openCount: 5,
      totalCount: 9,
      trend: "up",
      since: "rising this month",
      synopsis: "Limitation dropdown & inspection-ID cleanup.",
      ticketKeys: ["TICKET-22803"],
    },
    {
      id: "po",
      name: "PO ↔ job linking",
      openCount: 4,
      totalCount: 11,
      trend: "flat",
      since: "steady",
      synopsis: "Unlinking / re-linking POs across jobs.",
      ticketKeys: ["TICKET-22903", "TICKET-22454"],
    },
    {
      id: "quality",
      name: "Quality register access",
      openCount: 3,
      totalCount: 3,
      trend: "up",
      since: "new",
      synopsis: "Register visibility & bulk export.",
      ticketKeys: ["TICKET-22897"],
    },
  ],
  roadmapSignals: [
    {
      text: "2 requests map to modules already porting to 4.16 — merge candidates: [ref:ticket:TICKET-22881] and the workpack auto-add ask.",
      refs: ["ticket:TICKET-22881"],
    },
    {
      text: "“COP on parts-issue screen” lives in the [ref:visit:avcraft/2026-07-02] action register with no ticket yet — needs bridging.",
      refs: ["visit:avcraft/2026-07-02"],
    },
  ],
};

const row = (
  key: string,
  summary: string,
  status: string,
  statusCategory: Ticket["statusCategory"],
  assignee: string | null,
  updated: string,
): Ticket => ({ key, summary, status, statusCategory, assignee, priority: "Low", updated, url: `${JIRA}/${key}` });

export const mockTickets: Ticket[] = [
  row("TICKET-22903", "Unlinking entire PO from a job", "In Progress", "indeterminate", "Shelley", "17/07/2026"),
  row("TICKET-22902", "Engineer Work Report", "In Progress", "indeterminate", "Jay Shipman", "17/07/2026"),
  row("TICKET-22803", "Garmin Inspections", "With Client", "indeterminate", "Jay Shipman", "17/07/2026"),
  row("TICKET-22897", "Access to Quality - Registers", "With Client", "indeterminate", null, "17/07/2026"),
  row("TICKET-22881", "Generating PDF / XLS Reports for PO's and TD's etc", "With Client", "indeterminate", "Jay Shipman", "15/07/2026"),
  row("TICKET-22454", "Auto Addition to Workpack Tasks", "Done", "done", "Jay Shipman", "14/07/2026"),
];
